import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { CostCenterAction, SubItemsSharedAction } from "../actions";
import * as costCenterApi from "../api/costCenter";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import { SetMessage } from "../assets/errorMessages";
import { reset } from "redux-form";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../assets/fetchAllPageTogether";

export function* watcherCostCenter() {
  yield takeLatest(types.GET_COST_CENTER_REQUEST, get);
  yield takeLatest(types.SHOW_COST_CENTER_REQUEST, show);
  yield takeLatest(types.REMOVE_COST_CENTER_REQUEST, remove);
  yield takeLatest(types.STORE_COST_CENTER_REQUEST, store);
  yield takeLatest(types.UPDATE_COST_CENTER_REQUEST, update);
}

function* get() {
  try {
    const response = yield fetchAllPages(
      getRequest,
      null,
      defaultNormalizerWithSeparateMetaObj,
      null,
      true
    );
    yield put(CostCenterAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(CostCenterAction.getListFailure(message));
  }
}
function getRequest(pageNumber = null) {
  return costCenterApi.getList(pageNumber);
}

function* show(action) {
  try {
    const response = yield call(showRequest, action.id);
    yield put(CostCenterAction.showSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(CostCenterAction.showFailure(message));
  }
}
function showRequest(id) {
  return costCenterApi.show(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    yield put(CostCenterAction.removeSuccess(action.id));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (action.goBack) {
      yield put(goBack());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(CostCenterAction.removeFailure());
  }
}
function removeRequest(id) {
  return costCenterApi.remove(id);
}

function* store(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(storeRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    // yield put(reset("projectSubItemForm"))
    yield put(CostCenterAction.storeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(CostCenterAction.storeFailure());
  }
}
function storeRequest(data) {
  return costCenterApi.store(data);
}

function* update(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(updateRequest, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(CostCenterAction.updateSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(CostCenterAction.updateFailure());
  }
}
function updateRequest(id, data) {
  return costCenterApi.update(id, data);
}
